export const FEATURED_VIDEO_ID = '752051450';
export const RECENT_DAYS_COUNT = 14;
